<template>
  <div ref="toast" class="d-none">
    <div class="toast align-items-center show" :class="classes" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="d-flex">
        <div class="toast-body">
          {{ text }}
        </div>
        <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast"></button>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, onUpdated, ref } from 'vue';
export default {
  props: {
    classes: {
      type: String,
      default: 'bg-success text-white',
    },
    show: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: 'Aktion erfolgreich ausgeführt.',
    },
  },
  setup(props) {
    const toast = ref('');
    onMounted(() => {
      if (props.show) {
        document.querySelector('.toast-container').appendChild(toast.value.firstChild.cloneNode(true));
      }
    });
    onUpdated(() => {
      document.querySelector('.toast-container').appendChild(toast.value.firstChild.cloneNode(true));
    });
    return { toast };
  },
};
</script>

<style lang="scss" scoped></style>
